const pre = 'IMPACTANALYSIS/TRADEPRICEDTODAY/';

export const SET_ALL_UNBOOKED_TRADES_CHECKED = `${pre}SET_ALL_UNBOOKED_TRADES_CHECKED`;
export const SET_TRADES_PRICED_TODAY = `${pre}SET_TRADES_PRICED_TODAY`;
export const SET_TRADE_CHECKED = `${pre}SET_TRADE_CHECKED`;
export const TRADE_PRICED_TODAY_LOADED = `${pre}TRADE_PRICED_TODAY_LOADED`;
export const SUBMIT_BOOKING_TRADES = `${pre}SUBMIT_BOOKING_TRADES`;

export const submitBookingTrades = data => ({
    type: SUBMIT_BOOKING_TRADES,
    data
});

export const tradePricedTodayLoaded = () => ({
    type: TRADE_PRICED_TODAY_LOADED
});

export const setAllUnbookedTradesChecked = checked => ({
    type: SET_ALL_UNBOOKED_TRADES_CHECKED,
    checked
});

export const setTradesPricedToday = trades => ({
    type: SET_TRADES_PRICED_TODAY,
    trades
});

export const setTradeChecked = (checked, id) => ({
    type: SET_TRADE_CHECKED,
    checked,
    id
});
